import React, { useEffect, useState } from 'react';
import { Cell, Label, Pie, PieChart, ResponsiveContainer, Tooltip } from 'recharts';
import { GraphArrow } from '../../../Assets/icons';
import { patientFlowOptions } from '../../../data';
import TabButton from '../../UI/TabButton';
import TabsContainer from '../../UI/TabsContainer';
import CustomLegend from '../CustomLegend';
import classes from './PatientFlow.module.css';
import { patientType } from '../../../data';
import { convertIntoISO } from '../../../Helpers';
const initialData = [
  { name: '', value: 0.01, numbers: '' },
  { name: '', value: 0.01, numbers: '' },
  { name: '', value: 0.01, numbers: '' },
  { name: '', value: 0.01, numbers: '' }
];
const COLORS = ['#3DCC87', '#84D6E8', '#A284E8', '#E62E2E'];
const Bullet = ({ backgroundColor, size }) => (
  <div
    className="CircleBullet"
    style={{
      backgroundColor,
      width: size,
      height: size
    }}
  />
);

const RADIAN = Math.PI / 180;
const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }) => {
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return (
    <text x={x} y={y} fill="white" textAnchor="middle" dominantBaseline="central">
      {`${(percent * 100).toFixed(0)}%`}
    </text>
  );
};

const CustomLabel = ({ viewBox: { cx, cy }, labelText }) => (
  <g transform={`translate(${cx - 50}, ${cy - 15})`}>
    <foreignObject width="100" height="40">
      <div
        xmlns="http://www.w3.org/1999/xhtml"
        style={{ display: 'flex', alignItems: 'center', marginLeft: '5px' }}>
        <GraphArrow size={15} fill="var(--slate-gray)" />
        <div style={{ marginLeft: '5px' }}>
          <div style={{ color: 'var(--slate-gray)', fontSize: '11px' }}>{labelText}</div>
        </div>
      </div>
    </foreignObject>
  </g>
);
const renderCustomLabel = ({ x, y, name }) => (
  <text x={x} y={y} fill="black" textAnchor="middle" dominantBaseline="central">
    {name}
  </text>
);

const PatientStatsDonut = ({ patientFlow, dateRange, onFilter }) => {
  console.log('patientFlow', patientFlow);
  const [selectedGender, setSelectedGender] = useState(patientFlowOptions[0]);
  const [selectedType, setSelectedType] = useState(patientType[0]);
  const [data, setData] = useState(initialData);
  useEffect(() => {
    if (patientFlow)
      setData(
        patientFlow?.map((data) => ({
          name: data?.dataCaption,
          value: data?.data,
          numbers: +data?.dataValue || 0.01
        }))
      );
  }, [patientFlow]);
  return (
    <div className={classes.container}>
      <h2 className={classes.title}>Patient Flow</h2>
      {/* === top wrapper for patient === */}
      <TabsContainer
        className={classes.tabsContainer}
        tabsContent={patientType?.map((tab) => (
          <TabButton
            tab={tab?.label}
            active={tab?.label === selectedType?.label}
            onClick={() => {
              onFilter({
                startUtcDate: convertIntoISO(dateRange[0]?.startDate),
                endUtcDate: convertIntoISO(dateRange[0]?.endDate),
                chartType: tab?.value,
                genderId: selectedGender?.value
              });
              setSelectedType(tab);
            }}
          />
        ))}>
        <div className={classes.innerWrapper}>
          {/* === inner tabs for gender === */}
          <TabsContainer
            tabsContent={patientFlowOptions?.map((tab) => (
              <TabButton
                tab={tab?.label}
                active={selectedGender?.label === tab?.label}
                onClick={() => {
                  onFilter({
                    startUtcDate: convertIntoISO(dateRange[0]?.startDate),
                    endUtcDate: convertIntoISO(dateRange[0]?.endDate),
                    chartType: selectedType?.value,
                    genderId: tab?.value
                  });
                  setSelectedGender(tab);
                }}
              />
            ))}>
            {/* This is the content inside tabs Container */}
            <div className={classes.wrapper}>
              <ResponsiveContainer width="100%" height="100%">
                <PieChart margin={{ top: -50, right: 0, bottom: 0, left: 0 }}>
                  <Pie
                    minAngle={0.5}
                    dataKey="numbers"
                    data={data}
                    cx="50%"
                    innerRadius="25%"
                    outerRadius="60%"
                    label={renderCustomizedLabel}
                    isAnimationActive={false}
                    labelLine={false} // Disables the connector lines
                    fill="#82ca9d">
                    {data.map((entry, index) => (
                      <Cell
                        key={`cell-${index}`}
                        fill={COLORS[index % COLORS.length]}
                        stroke="none"
                      />
                    ))}
                    <Label
                      content={
                        <CustomLabel
                          labelText={`${patientFlow
                            ?.reduce(
                              (accumulator, current) =>
                                accumulator + parseFloat(current?.dataValue || 0),
                              0
                            )
                            ?.toFixed(2)} Patients`}
                        />
                      }
                      position="center"
                    />
                  </Pie>
                  <Tooltip />
                </PieChart>
              </ResponsiveContainer>
            </div>
            <ul>
              {data?.map((data, index) => (
                <CustomLegend {...{ ...data, color: COLORS[index] }} />
              ))}
            </ul>
          </TabsContainer>
        </div>
      </TabsContainer>
    </div>
  );
};
export default PatientStatsDonut;
